// useCompanies — the company list (GET /v1/companies).
import { useQuery } from "@tanstack/react-query";

import { listCompanies, type ListCompaniesParams } from "@/api/companies";
import { useAuth } from "@/store/auth";

export function useCompanies(params: ListCompaniesParams = {}) {
  const status = useAuth((s) => s.status);
  return useQuery({
    queryKey: ["companies", params],
    queryFn: () => listCompanies(params),
    enabled: status === "authenticated",
    staleTime: 60_000,
  });
}
